<div class="list-group-item edit-menu-item">
  <div class="row">
    <div class="col">
      <span class="fa-solid fa-grip-vertical mr-2 text-muted"></span>
      <div class="edit-menu-item-icon">
        <span class="{{iconClass}}"></span>
      </div>
      <span [innerText]="nodeUserMenuItem.name"></span>
    </div>
    <div class="col-auto">
      <div class="edit-menu-item-functions">
        <div class="d-inline-flex" ngbDropdown>
          <button class="btn btn-xs btn-outline-primary dropdown-no-arrow" id="dropdownBasic1" ngbDropdownToggle>
            <span class="fa-solid fa-ellipsis-vertical"></span>
          </button>
          <div aria-labelledby="dropdownBasic1" ngbDropdownMenu>
            <button (click)="editPage()" ngbDropdownItem>
              <span class="fa-solid fa-pen"></span>
              {{'Edit page'|translate}}
            </button>
            @if (isAdminOrHigher) {
              <button (click)="sharePage(nodeUserMenuItem)" ngbDropdownItem>
                <span class="fa-solid fa-eye"></span>
                {{'Share page'|translate}}
              </button>
            }
            <button (click)="deletePage(nodeUserMenuItem)" class="text-danger" ngbDropdownItem>
              <span class="fa-solid fa-trash"></span>
              {{'Delete page'|translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (editPageName && formIsActive) {
    <scitis-edit-page-inline-form (newPageCancel)="onCancelSavePage()" (newPageSave)="onSavePage($event)"
      [baseMenuItems]="baseMenuItems" [pageItem]="nodeUserMenuItem"
      [userMenuItems]="userMenuItems"
      [pageTypeOptions]="pageTypeOptions"
      [allPagesInsideNode]="allPagesInsideNode">
    </scitis-edit-page-inline-form>
  }
</div>
